module.exports = __webpack_public_path__ + "static/media/lily.e04b10b4.jpg";